import { lazy, Suspense, type ReactElement } from 'react';
import { Route, Routes } from 'react-router-dom';

import { ParentApp } from './parent/App';

const AdminApp = lazy(async () => {
  const module = await import('./admin/App');
  return { default: module.AdminApp };
});

export function App(): ReactElement {
  return (
    <Routes>
      <Route
        path="/admin/*"
        element={
          <Suspense fallback={null}>
            <AdminApp />
          </Suspense>
        }
      />
      <Route path="/*" element={<ParentApp />} />
    </Routes>
  );
}
